import { captureEvent } from '../metrics/captureEvent'

/**
 * Captures form submitted
 */
export function captureSubmitEvent() {
  captureEvent('form-submitted')
}
